import seeds from "../../src/cve/embedded-seeds.json";
import type { CveEntry } from "../../src/cve/normalize.js";

/** The embedded fallback pool, so the stream is never dead. */
export const EMBEDDED_SEEDS: CveEntry[] = (seeds.entries as CveEntry[]).slice();
